import axios from '@/api/axios';
import Vapi from 'vuex-rest-api';

const store = new Vapi({
  axios,
  state: {
  },
})
  .put({
    action: 'getSubscriptionsList',
    path: '/shop/subscriptions/list',
  })
  .put({
    action: 'getAggregatedSubscriptions',
    path: '/shop/subscriptions/aggregated',
  })
  .post({
    action: 'addSubscriptions',
    path: () => '/shop/subscriptions',
  })
  .post({
    action: 'getSubscriptionsReport',
    requestConfig: {
      responseType: 'blob',
    },
    path: '/shop/subscriptions/report',
  })
  .put({
    action: 'removeSubscriptions',
    path: () => '/shop/subscriptions/remove',
  })
  .put({
    action: 'removeSubscriptionsFromReserveQueue',
    path: () => '/shop/subscriptions/reserve-remove',
  })
  .put({
    action: 'moveSubscriptionsToReserveQueue',
    path: () => '/shop/subscriptions/reserve-add',
  })
  .put({
    action: 'promoteSubscriptionsFromReserveQueue',
    path: () => '/shop/subscriptions/reserve-promote',
  })
  .get({
    action: 'getListingFormLayout',
    path: () => '/shop/subscriptions/listing-layout',
  })
  .put({
    action: 'moveSubscriptionsToListing',
    path: () => '/shop/subscriptions/move',
  })
  .put({
    action: 'setCatalogSubscriptionsLayout',
    path: ({ catalogId }) => `/shop/catalogs/${catalogId}/layout/subscriptions`,
  })
  .get({
    action: 'getReportSubscriptions',
    path: () => '/shop/config/subscriptions',
  })
  .post({
    action: 'addReportSubscription',
    path: () => '/shop/config/subscriptions',
  })
  .put({
    action: 'updateReportSubscription',
    path: ({ id }) => `/shop/config/subscriptions/${id}`,
  })
  .put({
    action: 'toggleReportSubscription',
    path: ({ id }) => `/shop/config/subscriptions/${id}/send`,
    requestConfig: {
      responseType: 'blob',
    },
  })
  .delete({
    action: 'removeReportSubscription',
    path: ({ id }) => `/shop/config/subscriptions/${id}`,
  })
  .getStore();

store.getters = {
};

export default store;
